// @flow

import window from 'window';
import _ from 'lodash';
import TraceKit from 'tracekit';

import postscribeScript from 'postscribe-script';

const YANDEX_SMART_CAPTCHA_JS = 'https://smartcaptcha.yandexcloud.net/captcha.js';

const YANDEX_SMART_CAPTCHA_CLIENT_KEY = 'ysc1_eN8sl2N0dNaOAKp2KOCkmUIwmmJolJiamk9QRBBf7869f1fb';

export const fetchYandexSmartCaptchaJsOnce = () => {
	if (!window.__YCaptchaReady__) {
		window.__YCaptchaReady__ = postscribeScript(YANDEX_SMART_CAPTCHA_JS)
			.catch(e => {
				TraceKit.tryReport(
					`YaCaptcha: Ошибка загрузки JS для smartCaptcha`,
					{ quiet: true });
				throw e;
			});
	}

	return window.__YCaptchaReady__;
};

type YandexSmartCaptchaOptions = {
	onBeforeRender: ?(() => void),
	onSuccess: ?(() => void),
	onJsCriticalError: ?(() => void),
	onNetworkError: ?(() => void),
}

type YandexSmartCaptchaRenderOptions = {
	withChallenge: ?boolean;
}

export class YandexSmartCaptcha {
	constructor (elementId, options: YandexSmartCaptchaOptions = {}) {
		this._elementId = elementId;
		this._widgetId = undefined;

		this._onBeforeRender = options.onBeforeRender;
		this._onSuccess = options.onSuccess;
		this._onJsCriticalError = options.onJsCriticalError;
		this._onNetworkError = options.onNetworkError;
	}

	render (options: YandexSmartCaptchaRenderOptions = {}) {
		this._onBeforeRender && this._onBeforeRender();

		this.destroy();

		setTimeout(() => {
			this._widgetId = window.smartCaptcha.render(this._elementId, {
				sitekey: YANDEX_SMART_CAPTCHA_CLIENT_KEY,
				test: options.withChallenge,
				hl: 'ru',
				...this._getCaptchaRenderExtraProps(),
			});

			// console.log(`SmartCaptcha=${this._widgetId} rendered`);

			if (this._onSuccess) {
				window.smartCaptcha.subscribe(this._widgetId, 'success', this._onSuccess);
			}

			if (this._onJsCriticalError) {
				window.smartCaptcha.subscribe(
					this._widgetId,
					'javascript-error',
					this._onJsCriticalError);
			}

			if (this._onNetworkError) {
				window.smartCaptcha.subscribe(
					this._widgetId,
					'network-error',
					this._onNetworkError);
			}
		}, 0);
	}

	destroy () {
		if (!_.isNil(this._widgetId)) {
			window.smartCaptcha.destroy(this._widgetId);
			// console.log(`SmartCaptcha=${this._widgetId} destroyed`);

			this._widgetId = null;
		} else {
			// console.log('Captcha widget ain\'t exists. No need to destroy');
		}
	}

	reset () {
		if (!_.isNil(this._widgetId)) {
			window.smartCaptcha.reset(this._widgetId);
		} else {
			// console.log('Captcha widget ain\'t exists. No need to reset');
		}
	}

	startValidation () {
		// console.log(`starting to validate widget=${this._widgetId}`);

		window.smartCaptcha.execute(this._widgetId);
	}

	getValidationToken () {
		return window.smartCaptcha && window.smartCaptcha.getResponse(this._widgetId);
	}

	isValidated () {
		return Boolean(this.getValidationToken());
	}

	_getCaptchaRenderExtraProps () {
		return {};
	}
}

export class YandexSmartCaptchaInvisible extends YandexSmartCaptcha {
	constructor (elementId, options: YandexSmartCaptchaOptions = {}) {
		super(elementId, options);
	}

	_getCaptchaRenderExtraProps () {
		return {
			...super._getCaptchaRenderExtraProps(),
			invisible: true,
		};
	}
}